var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-blog-insights"},[_c('blog-container',{attrs:{"theme":_vm.theme}},[_c('blog-insights',{attrs:{"title":_vm.title,"lead":_vm.lead,"link":_vm.link,"spotlighted-card":_vm.spotlightedCard,"news-title":_vm.newsTitle,"news":_vm.CPCNews,"news-video-label":_vm.videoLabel,"cards":_vm.featuredCPCCards}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }